import { render, staticRenderFns } from "./rightBar.vue?vue&type=template&id=28452236&"
import script from "./rightBar.vue?vue&type=script&lang=js&"
export * from "./rightBar.vue?vue&type=script&lang=js&"
import style0 from "./rightBar.vue?vue&type=style&index=0&id=28452236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports